module.exports = __webpack_public_path__ + "static/media/marker_bus_stop_closed_hover.fa5431bc.svg";